/* Created by Interactive 63 - https://interactive63.com */
/**
 * Turns untrusted stored or uploaded project data into a safe `Project`. IndexedDB records and
 * project files can both be edited by anything with access to them, so each passes through
 * migration, validation and SVG sanitisation before it reaches the editor.
 */
import { sanitiseSvg } from '../../core/import/sanitise';
import { migrateProject, validateProject } from '../../core/model/schema';
import type { Project } from '../../core/model/types';

export type ProjectRecordResult = { ok: true; project: Project } | { ok: false; errors: string[] };

/** Replaceable sanitiser so tests can run without a real browser DOM. */
export type Sanitiser = (markup: string) => string;

/** Migrates, validates and sanitises raw project data. */
export function readProjectRecord(
  raw: unknown,
  sanitise: Sanitiser = sanitiseSvg,
): ProjectRecordResult {
  const result = validateProject(migrateProject(raw));
  if (!result.ok) return result;
  const source = sanitise(result.project.svg.source);
  if (source === '') return { ok: false, errors: ["The project's SVG could not be read."] };
  return {
    ok: true,
    project: { ...result.project, svg: { ...result.project.svg, source } },
  };
}
